import { createModal } from '@thermon-platforms/thermon-ui-core';
import { Trans } from '@lingui/react/macro';
import Modal from './modal';


function RefreshController ({device}) {
  function handleClick() {
    return createModal(<Modal device={device} />)
      .open()
      .catch(() => {/* no-op */});
  }

  return (
    <div className="secondary-management-section">
      <h3><Trans>Refresh Controller</Trans></h3>
      <p>
        <Trans>
          If the controller and/or its circuits are not responding,
          you can refresh the controller to attempt to restore communication.
        </Trans>
      </p>
      <button onClick={handleClick}>
        <Trans>Refresh</Trans>
      </button>
    </div>
  );
}

export default RefreshController;
